import detail from './detail'
import songs from './songs'

export default {
  songs,
  detail
}
